export default __webpack_public_path__ + "static/media/linkedin.e85f4eaa.svg";